{
    "required": "Please fill out this field.",
    "required_short": "Please fill this out.",
    "email": "Please enter a valid email address.",
    "phone": "Please enter a valid phone number. Format: +49 12345678912",
    "iban": "IBAN is not valid.",
    "bic": "BIC is not in a valid format.",
    "account_number": "Account number is not valid.",
    "sort_code": "Sort code is not valid.",
    "vat": "VAT number is not in a valid format.",
    "name": "Please enter a valid name.",
    "url": "Invalid URL (e.g., http://finway.de)",
    "number": "Please enter a valid number.",
    "not_zero": "Must not be 0.",
    "integer": "Please enter valid integer.",
    "string": "Please enter a valid string.",
    "string_too_long": "Input is too long.",
    "string_too_short": "Input is too short.",
    "string_white_space_start_or_end": "Please remove white spaces at start and end.",
    "string_white_space": "Please remove white spaces.",
    "string_white_space_duplicate": "Please remove duplicate spaces.",
    "alternative_budget_period": "Please enter an alternative period",
    "unique": "{{value}} must be unique.",
    "duplicate": "{{value}} duplicate.",
    "cannot_be_in_past": "Date cannot be in the past.",
    "cannot_be_in_future": "Date cannot be in the future.",
    "numeric_min_max": "Must be between {{min}} and {{max}}.",
    "only_letters": "Only letters or white spaces (no umlauts or special characters).",
    "only_letters_including_umlauts": "Only letters or white spaces (no special characters).",
    "invalid_characters": "Invalid characters.",
    "beneficiary_name_characters": {
        "sepa": "Contains characters the bank does not accept. Use letters, digits, spaces and . , ' - / ? : ( ) + & only.",
        "faster_payments": "Contains characters the bank does not accept. Use unaccented letters, digits, spaces and . , ’ - / ? : ( ) + # = ! \" % & * < > ; { @ only. For an apostrophe, use ’ instead of '."
    },
    "out_of_range": {
        "date": "Date is outside the permitted period."
    },
    "between": {
        "number": {
            "exclusive_min_inclusive_max": "Must be larger than {{min}} and less or equal than {{max}}."
        }
    },
    "min": {
        "string": "Please enter at least {{min}} characters.",
        "number": "Only values >= {{min}} are allowed.",
        "number_negative": "Only values < {{min}} are allowed.",
        "number_short": "Must be >= {{min}}.",
        "number_very_short": "Min: {{min}}"
    },
    "greater": {
        "string": "Please enter more than {{min}} characters.",
        "number": "Only values > {{min}} are allowed.",
        "number_short": "Must be > {{min}}."
    },
    "exact": {
        "string": "Must be {{num}} characters."
    },
    "max": {
        "string": "Cannot be more than {{max}} characters.",
        "number": "Max: {{max}}"
    },
    "below": {
        "string": "Please enter less than {{max}} characters.",
        "number": "Only values < {{max}} are allowed.",
        "number_short": "Must be < {{max}}."
    },
    "date_after": "{{attribute}} earlier than {{compare}}.",
    "date_before": "{{attribute}} later than {{compare}}.",
    "bigger_amount": "{{attribute}} cannot be bigger than {{compare}}.",
    "smaller_amount": "{{attribute}} cannot be smaller than {{compare}}.",
    "password": {
        "notmatching": "The passwords aren't matching.",
        "disallowed_word": "Password contains disallowed wording.",
        "password_has_leading_or_trailing_spaces": "Password cannot start or end with spaces.",
        "password_must_have_at_least_one_special_symbol": "Password must have at least one special symbol (!, @, #, $, %, etc)."
    },
    "rejection_note": "Rejection note missing",
    "invoice_needed": "You need to upload at least one invoice file.",
    "stripe_payment": {
        "invalid_fields": "Please fill out all fields.",
        "invalid_card": "This card number is invalid.",
        "missing_card_info": "Please fill out the card information."
    },
    "extended_alphanumeric": "No special characters allowed.",
    "limit_approver": "Approver has to be an admin or approver in the same department.",
    "numeric": "Only numbers are allowed.",
    "no_leading_zero": "No leading zero allowed.",
    "subject_contains_unsupported_character": "Subject contains unsupported character",
    "date_in_the_future": "Date in the future.",
    "no_empty_comment": "Please enter a comment message.",
    "date_birthday": "Age is invalid, must be at least 18 years old",
    "date_of_birth_missing": "Please enter your date of birth.",
    "date_of_birth_in_future": "Date of birth must be in the past.",
    "taxId": "Tax ID should have at least 8 characters",
    "shares_percentage": "Company ownership percentage should be between 0 and 100.",
    "shares_percentage_value": "All company shares from the directors and the shareholders should not exceed 100%.",
    "only_uppercase": "Only uppercase allowed.",
    "accept_terms": "Please agree to the terms.",
    "start_date": "Start date",
    "end_date": "End date",
    "bu_code": "BU code",
    "account_code": "Code",
    "account_name": "Name",
    "date_range_max_months": "Date range must be within {{max}} months.",
    "date_range_max_quarters": "Date range must be within {{max}} quarters.",

    "date_range_max_years": "Date range must be within {{max}} years.",
    "duplicate_approver": "Workflow rule cannot have duplicate approver.",
    "duplicate_limit_approver": "Cannot have duplicate approver.",
    "duplicate_approval_limit": "Cannot have duplicate limit.",
    "bu_code_validation": "Incompatible to DATEV.",
    "expense_account_code_validation": "Incompatible to DATEV.",
    "card_limit_change_reason": "Please specify a reason for the limit change.",
    "auto_approver_not_allowed_for_conditions": "Auto approver not allowed for conditional rules.",
    "approver_cannot_be_the_requester": "Approver cannot be the requester.",
    "responsible_employee_only_with_trigger_type_cost_center": "\"Responsible employee\" option can only be selected with trigger type \"Cost center 1\".",
    "subscription": {
        "started_on_later_than_renewal_date": "Performance date can't be on the same date or later than Contract renews on date.",
        "renewal_date_earlier_than_started_on": "Contract renews on can't be on the same date or earlier than the Performance date."
    },
    "per_diem": {
        "invalid_input": "Invalid input is detected in the form:",
        "end_date_less_than_last_transfer_date": "Return date before transfer date",
        "end_date_less_than_transfer_date": "Transfer date before start date",
        "end_date_less_than_start_date": "Return date before start date",
        "start_date_more_than_end_date": "Start date after transfer/return date",
        "end_time_less_than_last_transfer_time": "Return time before transfer time",
        "end_time_less_than_transfer_time": "Transfer time before start time",
        "end_time_less_than_start_time": "Return time before start time",
        "start_time_more_than_end_time": "Start time after transfer/return time",
        "destinations_invalid": "Destination fields are not properly set up",
        "destination_dates_invalid": "Destination dates are not properly set",
        "months_maximum": "Your trip has exceeded the {{months}} month period. Please reach out to your finance team, since regular per diem reimbursements do not apply in this case",
        "invalid_table": "Reimbursement Table needs to be rebuilt.",
        "hoursMinimum_one": "You're not eligible for reimbursement because your business trip duration is less then {{count}} hour.",
        "hoursMinimum_other": "You're not eligible for reimbursement because your business trip duration is less then {{count}} hours."
    },
    "mileage": {
        "must_provide_reason": "Reason for additional distance is required."
    },
    "custom_bank_subject": "Subject line cannot have duplicates.",
    "csv_settings_headers_empty": "You have to select at least one header.",
    "csv_settings_name_unique": "The template name already in use.",
    "number_interval": "Please enter a valid number between {{min}} and {{max}}.",
    "export_status_not_supported": "The export format is not available for the selected status.",
    "no_whitespace_only": "Field may not consist of only whitespace.",
    "demote_fallback_approver": "This user is currently set up as this company's workflow fallback approver and therefore, cannot be demoted.",
    "user_deleted": "The user has been deleted.",
    "must_be_positive": "Must be positive",
    "required_mileage_stops": "Please fill in this field with a suggestion.",
    "sso_domain_can_not_be_an_email": "SSO domain can't be an email address",
    "period_too_long": "Period cannot be longer than {{max}} months.",
    "personio": {
        "tabs_one": "Error in {{tab, lowercase}} tab.",
        "tabs_other": "Error in {{tab, lowercase}} tabs.",
        "duplicate_email_one": "The email {{email}} is already on the exclusion list.",
        "duplicate_email_other": "The emails {{email}} are already on the exclusion list."
    },

    "invalid_address_format": "Invalid address format.",
    "number_exceeding_decimal_places": "Please enter a valid number with a maximum of {{decimal_places}} decimal places.",
    "work_phone_deletion_not_allowed": "Phone number cannot be removed due to card program participation."
}
